<div class="header">
  <h5>{{data.id}}</h5>
  <span>{{data.created_at|date:'short'}}</span>
</div>
<div class="content">
  <div class="images">
    @for (item of data.items; track $index) {
    <img
      ngSrc="{{item|shoppingCartItemImage|fileurl}}"
      width="80"
      height="100"
      [ngStyle]="{'margin-left':$index>0? '-40px':'0px'}"
      alt="product image"
    />
    }
  </div>
  <div class="details">
    <div class="line">
      <span>Subtotal: </span>
      <span><app-price [price]="data.subtotal"></app-price></span>
    </div>
    <div class="line">
      <span>Shipping Fee: </span>
      <span><app-price [price]="data.shipping_fee"></app-price></span>
    </div>
    <div class="line">
      <span>Total: </span>
      <span><app-price [price]="data.total"></app-price></span>
    </div>
  </div>
</div>
